///
/// Copyright (c) 2017-present, Siklu Ltd.
/// All rights reserved.
///

import { Directive, HostBinding } from '@angular/core';

@Directive({
    selector: 'div[windeGridStripedRows]',
    standalone: false
})
export class GridStripedRowsDirective {
    @HostBinding('class') buttonClass = 'winde-grid-striped-rows';
}
